import { render, staticRenderFns } from "./mLeaguesPanel.vue?vue&type=template&id=1581aa89&scoped=true"
import script from "./mLeaguesPanel.vue?vue&type=script&lang=js"
export * from "./mLeaguesPanel.vue?vue&type=script&lang=js"
import style0 from "./mLeaguesPanel.vue?vue&type=style&index=0&id=1581aa89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1581aa89",
  null
  
)

export default component.exports